'use client'

import NextLink from 'next/link'
import { usePathname } from 'next/navigation'
import { forwardRef } from 'react'

import { DEFAULT_LOCALE } from '@/constants'
import { env } from '@/utils'

import { IntlLink } from './routing'

export const Link = forwardRef<
	HTMLAnchorElement,
	Parameters<typeof IntlLink>[0]
>((props, ref) => {
	const pathname = usePathname()

	const isDefaultLocale =
		pathname.startsWith(`/${DEFAULT_LOCALE}`) ||
		env.LOCALE_LIST.every((locale) => !pathname.startsWith(`/${locale}`))

	return isDefaultLocale ? (
		<NextLink {...props} ref={ref} />
	) : (
		<IntlLink {...props} ref={ref} />
	)
})

Link.displayName = 'Link'
